import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import {
  BUSINESS_REGISTRATION_UNAVAILABLE_PATH,
  getBusinessRegistrationBlockedReason,
} from '../utils/businessRegistrationAccess';

const BusinessRegistrationUnavailablePage = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  const roleFromState = location.state?.blockedRole;
  const role = roleFromState || user?.role;
  const reason = getBusinessRegistrationBlockedReason(role);

  return (
    <div className="max-w-3xl mx-auto px-4 py-14 sm:px-6 lg:px-8">
      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-6 sm:p-8 shadow-sm">
        <p className="inline-flex items-center rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold tracking-wide text-amber-700">
          Access Notice
        </p>

        <h1 className="mt-4 text-2xl sm:text-3xl font-bold text-slate-900">
          {reason.title}
        </h1>

        <p className="mt-3 text-sm sm:text-base text-slate-700 leading-relaxed">
          {reason.message}
        </p>

        {isAuthenticated && user?.email && (
          <p className="mt-3 text-xs sm:text-sm text-slate-600">
            Signed in as: <span className="font-semibold">{user.email}</span> ({user.role})
          </p>
        )}

        <div className="mt-6 rounded-xl bg-white border border-amber-100 p-4 sm:p-5">
          <h2 className="text-sm font-semibold text-slate-900">What you need to do</h2>
          <ul className="mt-3 space-y-2 text-sm text-slate-700">
            {reason.nextSteps.map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="mt-2 h-1.5 w-1.5 rounded-full bg-amber-500" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/"
            className="inline-flex items-center rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-slate-700 transition-colors"
          >
            Go to Home
          </Link>
          <Link
            to="/login"
            className="inline-flex items-center rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
          >
            Sign in with another account
          </Link>
        </div>
      </div>

      <p className="mt-4 text-xs text-slate-500">
        If you opened this page from a saved URL, it is expected behavior. Protected routes redirect blocked roles to
        {` ${BUSINESS_REGISTRATION_UNAVAILABLE_PATH} `}.
      </p>
    </div>
  );
};

export default BusinessRegistrationUnavailablePage;
